<script setup>
    import {usePortalContentAndDesignStore} from "../../../../stores/partners/portalContentAndDesignStore";
    import {ref, computed, provide} from "vue";
    import mitt from "mitt";
    import TranslationPrefillSelectConfirm from "./TranslationPrefillSelectConfirm.vue";

    const portalContentAndDesignStore = usePortalContentAndDesignStore()

    const props = defineProps({
        availableTranslations: {
            type: Array,
            default: () => []
        },
        translations: {
            type: Array,
            default: () => {}
        }
    })

    const filteredTranslations = computed(() => {
        if (!search.value?.trim()) return props.translations;

        const lowerSearch = search.value.toLowerCase().trim();

        return props.translations
            .map((group) => {
                const matchedFields = group.fields?.filter((field) => {
                    const key = field.setting || '';
                    const value = portalContentAndDesignStore.translationSettings?.[key] || '';

                    return (
                        key.replaceAll(' ', '_').toLowerCase().includes(lowerSearch) ||
                        (typeof value === 'string' && value.toLowerCase().includes(lowerSearch))
                    );
                });

                if (matchedFields?.length) {
                    return {
                        ...group,
                        fields: matchedFields,
                    };
                }

                return null;
            })
            .filter(Boolean); // Remove null groups
    });

    const search = ref('');

    provide('emitter', mitt);
</script>

<template>
    <div>
        <div>
            <input
                type="text"
                v-model="search"
                placeholder="Search translations..."
                :class="portalContentAndDesignStore.getInputStyle"
            >
        </div>

        <div v-for="group in filteredTranslations" class="py-8 space-y-5">
            <div class="space-y-2">
                <h3 class="text-lg font-medium">
                    {{ group['label'] }}
                </h3>
            </div>
            <div class="grid grid-cols-2 col-span-2 gap-8 gap-y-4 items-center">
                <template v-for="field in group['fields']">
                    <div class="text-sm text-gray-500">
                        {{ field['en'] }}
                    </div>
                    <text-field
                        :name="field['setting']"
                        type="text"
                        v-model="portalContentAndDesignStore.translationSettings[field['setting']]"
                    ></text-field>
                </template>
            </div>
        </div>
    </div>
</template>

